<template>
    <answers ref="answers"
             code_question_group="GQ27"
             danger_code="MCAL15"
             :unique_category="true"
             control_question="QCAL167"
             :control_answer="true"
    />
</template>

<script>
import answers from '../../../components/answers.vue';

export default {
    name: 'index',
    components: {
        answers
    }
};
</script>
